module.exports = __webpack_public_path__ + "img/me.2a7f3c37.jpg";